<template>
        <v-select
          v-model="selected"
          :items="data"
          :label="label"
          outlined
          hide-details=true
          dense
          :name="rowname"
          :item-value="value"
          :item-text="text" 
        >
          <template slot="item" slot-scope="data">
            {{ trans(data.item[text]) }}
          </template>
          <template v-slot:selection="{ item }">
            <span v-if="item.short">{{ trans(item.short) }}</span>
            <span v-else-if="item.name">{{ trans(item.name) }}</span>
            <span v-else>{{ trans(item.text) }}</span>
          </template>
        </v-select>
</template>

<script>
  export default {
    props: ['rowdata', 'rowname', 'rowselected', 'label', 'itemtext', 'itemvalue'],
    data () {
      return {
        data: this.rowdata,
        value: this.getValue(),
        text: this.getText()
      }
    },
    methods: {
        getValue() {
          var value = "value";
          this.itemvalue != null ? value = this.itemvalue : null
          return value;
        },
        getText() {
          var text = "text";
          this.itemtext != null ? text = this.itemtext : null
          return text;
        }
    },
    computed: {
      selected () {
        return this.rowselected;
      }
    }
  }
</script>